import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface Props {
  value: string;
  name: any;
  placeholder: string;
  type: any;
  handleDate: (date: any) => void;
  label: any;
  errors: any;
  selected: any;
  register: any;
}
const LabelInsideDatePicker = (props: Props) => {
  function handleOnChange(date: any) {
    props.handleDate(date);
  }

  return (
    <div>
      {props.label !== null ? (
        <>
          <label htmlFor="">{props.label}</label>
        </>
      ) : null}
      <div
        className={
          props.errors && props.errors[props.name]?.message
            ? "label-inside-input-error input-container-wrapper"
            : "label-inside-input input-container-wrapper"
        }
      >
        <DatePicker
          className="input-control"
          selected={props.selected}
          onChange={(date) => handleOnChange(date)}
        />
        <div className="error-line">
          {props.errors && props.errors[props.name]?.message ? (
            <span>{props.errors[props.name]?.message}</span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default LabelInsideDatePicker;
